import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Form as BulmaForm } from '@codeparva/ui-components-library';
import { FormFieldsTypes } from './FormFieldsTypes';
import { getAsterisk } from './helper/GetAstrisk';
import { GetErrorMessageIcon } from './helper/GetErrorMessageIcon';
import { weakKey } from '../../utilities/weakKey';
import { DynamicFormTypes } from '../../sections/rentalPage';
// const StateSelect = (optionsUSA: any[], optionsCanada: any[]) => {
//   return (
//     <>
//       <optgroup label="U.S. States/Territories">
//         {optionsUSA.map((optn: DynamicFormTypes.TSelectOption) => (
//           <option
//             key={weakKey(optn)}
//             value={optn.value}
//             label={optn.key || optn.value}
//           />
//         ))}
//       </optgroup>
//       <optgroup label="Canadian Provinces">
//         {optionsCanada.map(
//           (optn: DynamicFormTypes.TSelectOption, index: number) => (
//             <option
//               key={index}
//               value={optn.value}
//               label={optn.key || optn.value}
//             />
//           )
//         )}
//       </optgroup>
//     </>
//   );
// };

export const SelectField = ({
  name,
  label,
  options,
  required,
}: FormFieldsTypes.ISelectField) => {
  const { Select } = BulmaForm;
  let { errors }: any = useFormikContext();
  const getMultiOption = () => {
    return options.map(optgroupdata =>
      Object.keys(optgroupdata).map(name => (
        <optgroup data-cy="optionsGroup" label={name}>
          {optgroupdata[name].map((optn: DynamicFormTypes.TSelectOption) => (
            <option
              key={weakKey(optn)}
              value={optn.value}
              style={{ color: 'black', backgroundColor: 'white' }}
            >
              {optn.key || optn.value}
            </option>
          ))}
        </optgroup>
      ))
    );
  };
  const getSingleOption = () => {
    return options.map((optn: DynamicFormTypes.TSelectOption) => (
      <option
        key={weakKey(optn)}
        value={optn.value}
        style={{ color: 'black', backgroundColor: 'white' }}
      >
        {optn.key || optn.value}
      </option>
    ));
  };
  return (
    <div className="is-flex is-flex-direction-column DynamicField ">
      {label && (
        <label htmlFor={name}>
          {label}
          {required === true && getAsterisk()}
        </label>
      )}
      <Field
        className="select is-black is-focused"
        id={name}
        name={name}
        as={Select}
        type="select"
        data-cy={`${name}-${required}`}
      >
        <option className="has-text-black">Please select {label}</option>
        {options.length === 1 ? getMultiOption() : getSingleOption()}
      </Field>
      {errors[name] ? (
        <div className="ErrorMessage is-flex is-align-items-center">
          {GetErrorMessageIcon()}
          {errors[name]}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
